import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { ConfigApi } from 'src/app/core/constants/api.constant';
import { AppConstant } from 'src/app/core/constants/app.constant';
import { IResponse } from 'src/app/shared/models/app';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { BehaviorSubject, Subject } from 'rxjs';
import { left } from '@popperjs/core';

@Injectable({
  providedIn: 'root'
})

export class AlertService extends BaseService {

  /*********************Constructor*********************/
  constructor(protected http: HttpClient, private cache: CacheResolverService) {
    super(http);
  }
  /*********************Constructor*********************/


  /*********************Service Methods*********************/
 
  reservationsUpdate$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  scheduledReservations$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  alertCount$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  reservationsLoaded = false;

  getnotes(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetNotes);
    return super.post(url, reqPayload).pipe(map((response: any) => {

      return response;
    }));
  } 

  getAlertCount(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.GetCount);
    return super.post(url, reqPayload).pipe(map((response: any) => { 
      return response;
    }));
  }
 
  dismissAlert(reqPayload: any) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.DismissAlert);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  /*********************Service Methods*********************/

  reservationDetails(customerShipToNum) {
    const data = {
      customerShipToNum: customerShipToNum
    }
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStub);
    return super.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }


  reservationDetailss(data) {
    const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStubReservations);
    return super.post(url,data);
 }

 restoredRsvCount(params){
  const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStub)
    return super.post(url,params);
 }

 refreshReservations(params){
  const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStub)
    super.post(url,params).subscribe((response:IResponse)=> {
      if (response && response.data) { 
        this.reservationsUpdate$.next(response.data); 
      }
    });;
 }

 getReservationCount(params){
  if (!this.reservationsLoaded) {
  const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStub)
  super.post(url,params).subscribe((response:IResponse)=> {
    if (response && response.data) {
     this.reservationRsp(response);
    }
  });
}
 }

 reservationRsp(response)
 {
  if (response.data.isOrderStubEnabled && response.data.reservationCount) { 
    this.scheduledReservations$.next(response.data);
    this.reservationsLoaded = true;
  }
  this.reservationsUpdate$.next(response.data);
 }
 

 isReservationsLoaded() {
  return this.reservationsLoaded;
}

 resetReservations() {
  this.reservationsLoaded = false;
}

 restoreReservation(params){
  const url = super.serviceUrl(this.apiConfig.config, ConfigApi.OrderStubRestoreReservations)
  return super.post(url,params);
 }
 
}


